/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type barrier_FullBarrier$ref = any;
export type barrier_updateBarrierOwner_MutationVariables = {|
  barrierId: any,
  ownerId?: ?any,
|};
export type barrier_updateBarrierOwner_MutationResponse = {|
  +barrierMutation: ?{|
    +updateBarrierOwner: {|
      +$fragmentRefs: barrier_FullBarrier$ref
    |}
  |}
|};
export type barrier_updateBarrierOwner_Mutation = {|
  variables: barrier_updateBarrierOwner_MutationVariables,
  response: barrier_updateBarrierOwner_MutationResponse,
|};
*/


/*
mutation barrier_updateBarrierOwner_Mutation(
  $barrierId: UUID!
  $ownerId: UUID
) {
  barrierMutation {
    updateBarrierOwner(barrierId: $barrierId, ownerId: $ownerId) {
      ...barrier_FullBarrier
      id
    }
  }
}

fragment barrier_FullBarrier on Barrier {
  id
  name
  description
  status
  pinned
  auditMeta {
    created
    createdBy {
      userName
      firstName
      lastName
      id
    }
    updated
    updatedBy {
      userName
      firstName
      lastName
      id
    }
  }
  category {
    code
    value
    sourceTypes {
      id
      code
      value
      active
      activeDirectorySourceName
      hasConfiguredList
      sourceDetails {
        id
        code
        value
        active
      }
    }
    id
  }
  escalation {
    auditMeta {
      created
      createdBy {
        userName
        firstName
        lastName
        id
      }
    }
    id
  }
  ownerMessageStatus
  ownerMessageStatusDate
  ownerKnownUser {
    id
    emailReceiver
    instantMessageReceiver
  }
  ownerMessageDeliveryDate
  owner
  ownerRole {
    code
    value
    id
  }
  sourceName
  sourceTypeCode
  notes {
    id
    text
    auditMeta {
      created
      createdBy {
        userName
        firstName
        lastName
        id
      }
      updated
      updatedBy {
        userName
        firstName
        lastName
        id
      }
    }
    pinned
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "barrierId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "barrierId",
    "variableName": "barrierId"
  },
  {
    "kind": "Variable",
    "name": "ownerId",
    "variableName": "ownerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "barrier_updateBarrierOwner_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierMutation",
        "kind": "LinkedField",
        "name": "barrierMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Barrier",
            "kind": "LinkedField",
            "name": "updateBarrierOwner",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "barrier_FullBarrier"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "barrier_updateBarrierOwner_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierMutation",
        "kind": "LinkedField",
        "name": "barrierMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Barrier",
            "kind": "LinkedField",
            "name": "updateBarrierOwner",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v3/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BarrierCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BarrierSourceType",
                    "kind": "LinkedField",
                    "name": "sourceTypes",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activeDirectorySourceName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasConfiguredList",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BarrierSourceDetail",
                        "kind": "LinkedField",
                        "name": "sourceDetails",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Escalation",
                "kind": "LinkedField",
                "name": "escalation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuditMeta",
                    "kind": "LinkedField",
                    "name": "auditMeta",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ownerMessageStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ownerMessageStatusDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "KnownUser",
                "kind": "LinkedField",
                "name": "ownerKnownUser",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailReceiver",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instantMessageReceiver",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ownerMessageDeliveryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CodeTablePair",
                "kind": "LinkedField",
                "name": "ownerRole",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceTypeCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BarrierNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b430871e3982084595c5099255c69cad",
    "id": null,
    "metadata": {},
    "name": "barrier_updateBarrierOwner_Mutation",
    "operationKind": "mutation",
    "text": "mutation barrier_updateBarrierOwner_Mutation(\n  $barrierId: UUID!\n  $ownerId: UUID\n) {\n  barrierMutation {\n    updateBarrierOwner(barrierId: $barrierId, ownerId: $ownerId) {\n      ...barrier_FullBarrier\n      id\n    }\n  }\n}\n\nfragment barrier_FullBarrier on Barrier {\n  id\n  name\n  description\n  status\n  pinned\n  auditMeta {\n    created\n    createdBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n    updated\n    updatedBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n  }\n  category {\n    code\n    value\n    sourceTypes {\n      id\n      code\n      value\n      active\n      activeDirectorySourceName\n      hasConfiguredList\n      sourceDetails {\n        id\n        code\n        value\n        active\n      }\n    }\n    id\n  }\n  escalation {\n    auditMeta {\n      created\n      createdBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n    }\n    id\n  }\n  ownerMessageStatus\n  ownerMessageStatusDate\n  ownerKnownUser {\n    id\n    emailReceiver\n    instantMessageReceiver\n  }\n  ownerMessageDeliveryDate\n  owner\n  ownerRole {\n    code\n    value\n    id\n  }\n  sourceName\n  sourceTypeCode\n  notes {\n    id\n    text\n    auditMeta {\n      created\n      createdBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n      updated\n      updatedBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n    }\n    pinned\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9bd0a417ad0cdad8918e471969d7212b';

module.exports = node;
